import React from 'react';
import { AlertTriangleIcon } from 'lucide-react';
import { Permission, PermissionId, promotionPermissions } from '../data/promotionPermissions';

// Shared between Settings and the Carli Analysis flow so a brand states its
// permissions the same way whether it is onboarding or already live.
export function PermissionList({
  denied,
  onToggle,
  permissions = promotionPermissions
}: {
  denied: PermissionId[];
  onToggle: (id: PermissionId) => void;
  permissions?: Permission[];
}) {
  return <ul className="space-y-2" data-id="element-2123" data-mp="374n4c49roxxv">
      {permissions.map(permission => {
      const allowed = !denied.includes(permission.id);
      return <li key={permission.id} className={`flex flex-wrap items-start justify-between gap-4 rounded-xl border p-4 transition-colors ${allowed ? 'border-ink/10 bg-cream/40' : 'border-[#BB5E40]/40 bg-[#BB5E40]/6'}`} data-id="element-2124" data-mp="2tejnxtxkjygc">
            <div className="min-w-0 flex-1" data-id="element-2125" data-mp="2od46ebuloa2p">
              <p className="text-sm font-semibold text-ink" data-id="element-2126" data-mp="2gybnjb1e1o38">{permission.label}</p>
              <p className="mt-1 text-xs leading-relaxed text-ink/60" data-id="element-2127" data-mp="2h04smlwcs094">{permission.detail}</p>
              {!allowed && <p className="mt-2 flex items-start gap-1.5 text-xs leading-relaxed text-[#94452E]" data-id="element-2128" data-mp="2pyq7o72m8x55">
                  <AlertTriangleIcon className="mt-0.5 h-3.5 w-3.5 shrink-0" aria-hidden="true" data-id="element-2129" data-mp="2lwv8b848wtu0" />
                  <span data-id="element-2130" data-mp="1y7kd065nzrn9">{permission.impact}</span>
                </p>}
            </div>
            <PermissionToggle label={permission.label} allowed={allowed} onChange={() => onToggle(permission.id)} data-id="element-2131" data-mp="1t996a4ao1x99" />
          </li>;
    })}
    </ul>;
}

// Two-state control so the granted and withheld states read equally clearly.
export function PermissionToggle({
  label,
  allowed,
  onChange
}: {
  label: string;
  allowed: boolean;
  onChange: () => void;
}) {
  return <div className="flex shrink-0 items-center gap-3" data-id="element-2132" data-mp="1ehgqjr6ymh70">
      <span className={`text-xs font-semibold ${allowed ? 'text-forest' : 'text-[#94452E]'}`} data-id="element-2133" data-mp="1ahgbc4c1e1yw">
        {allowed ? 'Allowed' : 'Not allowed'}
      </span>
      <button type="button" role="switch" aria-checked={allowed} aria-label={`${label}: ${allowed ? 'allowed' : 'not allowed'}`} onClick={onChange} className={`relative h-6 w-11 shrink-0 rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-[#BB5E40]/25 focus:ring-offset-2 focus:ring-offset-paper ${allowed ? 'bg-forest' : 'bg-ink/20'}`} data-id="element-2134" data-mp="3em2p4au5rsbz">
        <span className={`absolute top-0.5 h-5 w-5 rounded-full bg-paper shadow-sm transition-transform duration-150 ${allowed ? 'translate-x-[22px]' : 'translate-x-0.5'}`} data-id="element-2135" data-mp="2vo9ml9ng5kf4" />
      </button>
    </div>;
}